import React, { MouseEvent } from 'react'
import { getIsFirstTimeUser } from '@helpers/session/user'
import { analytics } from '@helpers/analytics'
import { ButtonLink } from '@components/ui/Button'
import styles from './styles.module.scss'

const ShopCollection = () => {
  const handleLinkClick = (ev: MouseEvent<HTMLAnchorElement>) => {
    ev.preventDefault()
    const firstTimeUser = getIsFirstTimeUser()
    analytics('Click', {
      category: 'Landing Page',
      label: 'Final CTA',
      action: 'Shop Collection',
      type: firstTimeUser ? 'new' : 'existing'
    })
    window.open(ev.currentTarget.href)
  }
  return (
    <div className={styles.container}>
      <img src="/static/images/enduros/enduros_man.png" alt="Shop Collection" />
      <h2>
        Ready to <span className={styles.leftTitle}>Enduro?</span>
      </h2>
      <ButtonLink
        href="/collections/enduros-range"
        variant="secondary"
        fullWidth="never"
        onClick={handleLinkClick}
      >
        Shop the Collection
      </ButtonLink>
    </div>
  )
}

export default ShopCollection
